import { useQuery } from "@tanstack/react-query"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { Badge } from "@/components/ui/badge"
import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { useNavigate } from "react-router-dom"
import { Skeleton } from "@/components/ui/skeleton"
import { getNPOHosts } from "@/lib/queries/npo"

export default function NPOHosts({ session, profile }: { session: any; profile: any }) {
  const navigate = useNavigate()

  const { data: hosts = [], isLoading } = useQuery({
    queryKey: ["npo-hosts", profile?.id],
    queryFn: () => getNPOHosts(profile?.id),
    enabled: !!profile?.id,
  })

  const handleRowClick = (hostId: string) => {
    navigate(`/dashboard/events/hosts/${hostId}`)
  }

  if (isLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-8 w-1/4" />
        <div className="border rounded-lg">
          <div className="space-y-4 p-4">
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Event Hosts</h1>
      </div>

      <div className="border rounded-lg">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Host</TableHead>
              <TableHead>Contact</TableHead>
              <TableHead>Events</TableHead>
              <TableHead>Latest Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {hosts.map((host) => (
              <TableRow 
                key={host.id} 
                className="cursor-pointer hover:bg-muted/50"
                onClick={() => handleRowClick(host.id)}
              >
                <TableCell>
                  <div className="flex items-center gap-3">
                    <Avatar>
                      <AvatarFallback>
                        {host.full_name.split(" ").map(n => n[0]).join("")}
                      </AvatarFallback>
                    </Avatar>
                    <div>
                      <div className="font-medium">{host.full_name}</div>
                      <div className="text-sm text-muted-foreground">
                        {host.email}
                      </div>
                    </div>
                  </div>
                </TableCell>
                <TableCell>{host.phone}</TableCell>
                <TableCell>{host.events_count} events</TableCell>
                <TableCell>
                  <Badge variant="secondary">
                    {host.latest_event_status.replace(/_/g, " ")}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
            {hosts.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} className="text-center py-6 text-muted-foreground">
                  No hosts found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}